import { render, staticRenderFns } from "./LomMembershipList.vue?vue&type=template&id=5b8dd1b6"
import script from "./LomMembershipList.vue?vue&type=script&lang=js"
export * from "./LomMembershipList.vue?vue&type=script&lang=js"
import style0 from "./LomMembershipList.vue?vue&type=style&index=0&id=5b8dd1b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports